export const PARAMETER_SUBSET_TYPE = {
    MODEL: 'model',
    OPERATOR: 'operator',
    CONTRACTOR: 'contractor',
    COLLECTION_POINT: 'collectionPoint',
    DEVICE: 'device',
};

export const PARAMETER_SUBSET_TYPE_ORDER = [
    PARAMETER_SUBSET_TYPE.MODEL,
    PARAMETER_SUBSET_TYPE.OPERATOR,
    PARAMETER_SUBSET_TYPE.CONTRACTOR,
    PARAMETER_SUBSET_TYPE.COLLECTION_POINT,
    PARAMETER_SUBSET_TYPE.DEVICE,
];

export const getAllowedChildSubsetTypes = parentType => {
    if (!parentType) {
        return PARAMETER_SUBSET_TYPE_ORDER;
    }

    const index = PARAMETER_SUBSET_TYPE_ORDER.indexOf(parentType);
    if (index < 0) {
        return PARAMETER_SUBSET_TYPE_ORDER;
    }

    return PARAMETER_SUBSET_TYPE_ORDER.slice(index + 1);
};

export const canAddChildSubset = parentType => getAllowedChildSubsetTypes(parentType).length > 0;

export const parameterSubsetTypeChoices = (translate, parentType) =>
    getAllowedChildSubsetTypes(parentType).map(id => ({
        id,
        name: translate(`resources.parameter.subsetTypes.${id}`),
    }));
